export default { mobileBreakpoint: "sm" };
